import { cloneDeep, isEqual } from 'lodash'

import { NOTIFICATIONS_AVAILABLE_TYPES } from '@sigma-legacy-libs/essentials/lib/constants'

import { balance } from '@/utils'

import render from './render'

const defaultValue = {
  balance: 0,
  types: [ NOTIFICATIONS_AVAILABLE_TYPES.email ],
  includeOverdraft: false,
  invoice: false
}

export default {
  name: 'NotificationsEventsBillingsLimit',

  mixins: [ balance() ],

  props: {
    path: {
      type: String,
      default: undefined
    },

    value: {
      type: Array,
      default: () => {
        return []
      }
    },

    // NOTE: currency и UserId добавляются из миксина balance
    // currency: String
    // UserId: String

    ResellerId: String,

    permission: {
      type: [ String, Boolean ],
      default: undefined
    }
  },

  data() {
    return {
      proxy: [],
      index: 0,

      showDialog: false
    }
  },

  mounted() {
    this.inputFilter()
  },

  methods: {
    add() {
      this.proxy.push(cloneDeep(defaultValue))
    },
    remove(index) {
      this.proxy.splice(index, 1)
    },

    inputFilter() {
      if (!isEqual(this.proxy, this.value)) {
        this.proxy = cloneDeep(this.value)
      }
    }
  },

  render
}
